<app-status-bar></app-status-bar>
<div class="refunds-page-wrapper">
  <div class="header-wrapper">
    <div class="back-button" (click)="goBack()">
      <fa-icon [icon]='faArrowLeft'></fa-icon>
      <p>Volver</p>
    </div>
  </div>
  <div class="content-wrapper">
    <div class="content-header-wrapper">
      <p class="title">Pedidos</p>
      <div class="table-actions-wrapper">
        <div class="filter-wrapper">
          <div class="searchbar">
            <fa-icon [icon]='faSearch'></fa-icon>
            <input #searchInput type="text" placeholder="Buscar pedido" [(ngModel)]="searchText"
              (input)="searchOrder(searchInput.value)">
          </div>
          <div class="filter-button" [class.filter-button-active]="activeFilters" (click)="openFilters()">
            <fa-icon [icon]='faSliders'></fa-icon>
            <p>Filtrar</p>
            <fa-icon [icon]='faTimes' *ngIf="activeFilters"></fa-icon>
          </div>
        </div>
        <!-- <div class="select-many-wrapper" *ngIf="multiSelectMode==false" (click)="multiSelectMode=true">
          <fa-icon [icon]='faListRadio'></fa-icon>
          <p>Seleccionar varios</p>
        </div> -->
        <div class="multi-refund-wrapper" *ngIf="multiSelectMode==true">
          <div class="select-many-wrapper" (click)="multiSelectMode=false; multiSelectArray=[]">
            <fa-icon [icon]='faTimes'></fa-icon>
            <p>Cancelar</p>
          </div>
          <div class="multi-refund-button" (click)="startMultiRefund()" [class.disabled]="multiSelectArray.length==0">
            <fa-icon [icon]='faRotateLeft'></fa-icon>
            <p>Devolver todos</p>
          </div>
        </div>
      </div>
      <div class="filter-selects-wrapper" *ngIf="activeFilters">
        <!-- Fecha -->
        <div #fechaDropdown>
          <mat-form-field appearance="fill" class="select-filter-panel"
            (click)="openDatePicker=!openDatePicker; openPriceRange=false">
            <input matInput placeholder="Fecha" class="input-date " readonly [(ngModel)]="stringDate">
            <mat-select-trigger matSuffix style="vertical-align: middle;">
              <i class="fal fa-angle-down "></i>
            </mat-select-trigger>
          </mat-form-field>
          <div class="calendar-dropdown" *ngIf="openDatePicker">
            <ngb-datepicker class="custom-datepicker-event" #dp [displayMonths]="1" [dayTemplate]="t"
              outsideDays="visible" (dateSelect)="changeDate($event)" [minDate]="minDate"
              (navigate)="dateNavigate($event)">
              <ng-template #t let-date let-focused="focused">
                <span class="custom-day" [class.focused]="fromDate != null && hoveredDate != null"
                  [class.first-select]="isFromDate(date)" [class.last-select]="isToDate(date)"
                  [class.faded]="isHovered(date) || isInside(date)" [class.border-monday]="isMonday(date)"
                  [class.border-sunday]="isSunday(date)" [class.range]="isRange(date)"
                  [class.day-disabled]="isDisabled(date)" (mouseenter)="hoveredDate = date"
                  (mouseleave)="hoveredDate = null">
                  <span class="inside-day" [class.weekend]="isWeekend(date)">{{ date.day }}</span>
                </span>
              </ng-template>
            </ngb-datepicker>
          </div>
        </div>
        <!-- Rango de precios -->
        <div #rangoDropdown>
          <mat-form-field appearance="fill" class="select-filter-panel "
            (click)="openPriceRange=!openPriceRange; openDatePicker=false">
            <input matInput placeholder="Precio del pedido" class="input-price " readonly
              [(ngModel)]="selectedPriceRange">
            <mat-select-trigger matSuffix style="vertical-align: middle;">
              <i class="fal fa-angle-down "></i>
            </mat-select-trigger>
          </mat-form-field>
          <div class="dialog-price-range" *ngIf="openPriceRange">
            <div class="slider-filter">
              <span>Selecciona un rango de precios:</span>
              <mat-slider min="0" max="10000" (change)="priceRangeChange()">
                <input [(ngModel)]="priceFilter.min" matSliderStartThumb>
                <input [(ngModel)]="priceFilter.max" matSliderEndThumb>
              </mat-slider>
              <div class="d-flex justify-content-between ">
                <span>{{priceFilter.min}}€</span>
                <span>{{priceFilter.max}}€</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Estado -->
        <mat-form-field appearance="fill" class="select-filter-panel" (click)="openPriceRange=false">
          <mat-select #selectStatus class="text-black" panelClass="selectPanelControl" placeholder="Estado" multiple
            [disabled]="loadingFilter" (selectionChange)="selectStatus.close()" [(ngModel)]="statusFilter"
            disableOptionCentering="false" (ngModelChange)="updateFilter()">
            <mat-option *ngFor="let status of statusOptionsList" [value]="status.id">
              <span>{{status.name}}</span></mat-option>
          </mat-select>
          <mat-select-trigger matSuffix style="vertical-align: middle;">
            <i class="fal fa-angle-down "></i>
          </mat-select-trigger>
        </mat-form-field>

        <!-- Metodo de pago -->
        <mat-form-field appearance="fill" class="select-filter-panel" (click)="openPriceRange=false">
          <mat-select #selectPay class="text-black" panelClass="selectPanelControl" placeholder="Método de pago"
            multiple [disabled]="loadingFilter" (selectionChange)="selectPay.close()" [(ngModel)]="methodFilter"
            disableOptionCentering="false" (ngModelChange)="updateFilter()">
            <mat-option *ngFor="let method of methodOptionsList" [value]="method.id">
              <span>{{method.name}}</span>
            </mat-option>
          </mat-select>
          <mat-select-trigger matSuffix style="vertical-align: middle;">
            <i class="fal fa-angle-down "></i>
          </mat-select-trigger>
        </mat-form-field>

        <!-- Eliminar filtros -->
        <!-- <div class="btn-clear-filter m-0" (click)="clearFilters()" *ngIf="filterActive">
              <i class="fal fa-times"></i>
              <p class="m-0">Limpiar</p>
          </div> -->
      </div>
    </div>
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" class="table-lines" matSort (matSortChange)="sortData($event)">
        <!-- ACTIONS -->
        <ng-container matColumnDef="allow_refund">
          <th mat-header-cell *matHeaderCellDef>Acciones</th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              *ngIf="multiSelectMode && getStatusClass(row.status)!=='refund' && getStatusClass(row.status)!=='pending_refund'"
              (change)="check($event.checked, row)"></mat-checkbox>
            <span *ngIf="getStatusClass(row.status)!=='refund' && getStatusClass(row.status)!=='pending_refund'"
              class="action-button" (click)="startRefund(row.id_transaction)">Devolver pedido</span>
            <span *ngIf="getStatusClass(row.status)=='refund' || getStatusClass(row.status)=='pending_refund'"
              class="action-button disabled">Pedido devuelto</span>
          </td>
        </ng-container>

        <!-- ID -->
        <ng-container matColumnDef="id_order">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ID pedido</th>
          <td mat-cell *matCellDef="let row" class="row-color" style="cursor: pointer;"
            (click)="goToDetail(row.id_transaction)"><span class="clickable-text">{{
              row.id_order
              }}</span></td>
        </ng-container>

        <!-- SOLD -->
        <ng-container matColumnDef="cash_register">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendido en</th>
          <td mat-cell *matCellDef="let row" class="row-color" style="cursor: pointer;"
            (click)="goToDetail(row.id_transaction)">{{ row.cash_register }}</td>
        </ng-container>

        <!-- CHANNEL -->
        <ng-container matColumnDef="channel">
          <th mat-header-cell *matHeaderCellDef>Canal</th>
          <td mat-cell *matCellDef="let row" class="row-color" style="cursor: pointer;"
            (click)="goToDetail(row.id_transaction)">{{ row.channel }}</td>
        </ng-container>

        <!-- DATE -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha y hora trans.</th>
          <td mat-cell *matCellDef="let row" class="row-color" style="cursor: pointer;"
            (click)="goToDetail(row.id_transaction)">
            {{ row.date | date: 'd/M/yy HH:mm' }}
          </td>
        </ng-container>

        <!-- PRICE -->
        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Precio</th>
          <td mat-cell *matCellDef="let row" class="row-color" style="cursor: pointer;"
            (click)="goToDetail(row.id_transaction)">{{ row.price }}€</td>
        </ng-container>

        <!-- STATE -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
          <td mat-cell *matCellDef="let row" class="row-color" [class]="getStatusClass(row.status)"
            style="cursor: pointer;" (click)="goToDetail(row.id_transaction)">
            <div class="status-line">
              <fa-icon [icon]='faCircle'></fa-icon>
              <span>{{row.status}}</span>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      
      <!-- Spinner de carga para paginación -->
      <div class="loading-spinner" *ngIf="loadingMore">
        <mat-progress-spinner color="accent" mode="indeterminate" diameter="40">
        </mat-progress-spinner>
      </div>
    </div>
  </div>
</div>